const FIXED_VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1.0, viewport-fit=cover'

function syncViewportMeta() {
  const viewportMeta = document.querySelector('meta[name="viewport"]')
  if (!viewportMeta) {
    return
  }

  viewportMeta.setAttribute('content', FIXED_VIEWPORT_CONTENT)
}

export function installMobileViewportGuard() {
  if (typeof document === 'undefined') {
    return
  }

  syncViewportMeta()
}
